import { render } from "./CellContainer.vue?vue&type=template&id=52cf046a&scoped=true"
import script from "./CellContainer.vue?vue&type=script&lang=js"
export * from "./CellContainer.vue?vue&type=script&lang=js"

import "./CellContainer.vue?vue&type=style&index=0&id=52cf046a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52cf046a"

export default script